export default __webpack_public_path__ + "static/media/Screed.47eaa217.png";